import React, { useState } from "react";
import styles from "./style.module.css";
import { UserCommonStyles } from "../../../styles/CommonStyles";
import { Box, Grid, Button } from "@mui/material";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useDispatch } from "react-redux";
import {
  productCheckout,
  sendBuyerNotification,
} from "../../../redux/action-creators/orderAction";
import { toast } from "../../../utils/toastsMessage";
import { Type } from "../../../utils/constants";
import { productCountHandler } from "../../../components/header/Header";
import ClipLoader from "react-spinners/ClipLoader";

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#c4f0ff",
      color: "#fff",
      fontWeight: 500,
      fontFamily: "Roboto, Open Sans, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": { color: "#fce883" },
      "::placeholder": { color: "#87bbfd" },
    },
    invalid: {
      iconColor: "#ffc7ee",
      color: "#ffc7ee",
    },
  },
};

const StripePaymentMethod = ({ checkoutData, shippingAddress, setOpen }) => {
  const stripe = useStripe();
  const elements = useElements();
  const commonStyle = UserCommonStyles();
  const dispatch = useDispatch();
  const userId: number = Number(localStorage.getItem("userId"));
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const onSubmit = async () => {
    setIsDisabled(true);
    const stripe_data = {
      address: {
        city: shippingAddress?.city,
        postal_code: shippingAddress?.zip,
        // state: shippingAddress?.state,
      },
      email: shippingAddress?.email,
      name: shippingAddress?.firstname + " " + shippingAddress?.lastname,
      phone: shippingAddress?.phone_number,
    };

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: stripe_data,
    });
    if (error) {
      setIsDisabled(false);
      return toast.error(error.message ? error.message : "");
    } else if (paymentMethod?.id) {
      // const formatProductArray = checkoutData?.product.map(({seller_id, available_quantity, ...rest}) => rest);
      // console.log('formatProductArray :>> ', formatProductArray);
      const checkout_data = {
        cart: checkoutData?.product,
        address:
          checkoutData?.different_address && shippingAddress?.diff_address
            ? shippingAddress?.diff_address
            : shippingAddress?.address,
        delivery_price: checkoutData?.deliveryRate,
        tax: Number(checkoutData?.tax.toFixed(2)),
        payment_id: paymentMethod?.id,
        post_code: shippingAddress?.zip,
        country: shippingAddress?.city,
        zip: Number(shippingAddress?.zip),
        city: shippingAddress?.city,
        phone_number: shippingAddress?.phone_number,
        email: shippingAddress?.email,
        seller_id: checkoutData?.product[0]?.seller_id
      };
    console.log('checkout_data :>> ', checkout_data);
      const response: any = await dispatch(
        productCheckout(userId, checkout_data)
      );
   
      if (response && response?.status === 201) {
        // const notificationBody = {
        //   type: "Order placed",
        //   buyer_id: userId,
        //   order_id: response?.data?.orderId,
        // };
        // const Noti_response: any = await dispatch(
        //   sendBuyerNotification(notificationBody)
        // );
        productCountHandler(0);
        localStorage.removeItem(Type?.shoppingBag);
        localStorage.removeItem(Type?.shoppingCartCheckout);
        setIsDisabled(false);
        setOpen(true);
      } else {
        setIsDisabled(false);
        return toast.error("Something went wrong. Please try again later.");
      }
    } else {
      setIsDisabled(false);
      return toast.error("Something went wrong. Please try again later.");
    }
  };
  return (
    <div className={styles.shipping_address_form}>
      <form onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item md={12}>
            {/* Stripe Default field /////////////// */}
            <Grid container spacing={0} mt={4}>
              <Grid item md={1}></Grid>
              <Grid item md={10}>
                <CardElement
                  className={styles.card_element}
                  // options={CARD_OPTIONS}
                  options={{
                    style: {
                      base: {
                        fontSize: "20px",
                        color: "#32325d",
                        fontFamily:
                          "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                        "::placeholder": {
                          color: "#a0aec0",
                        },
                      },
                      invalid: {
                        color: "#9e2146",
                        backgroundColor: "#f5d4d3",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item md={1}></Grid>
            </Grid>

            {/* <Grid item md={12}>
                            <Box className={commonStyle.commonInput}>
                                <Typography
                                    className={commonStyle.labelCommonInput}
                                >
                                    Card Number
                                </Typography>
                                <TextField
                                    placeholder={"xxxxx-xxxx-xxxx-xxxx"}
                                    className={commonStyle.w100}
                                />
                                <span className={commonStyle.errorMsg}>
                                </span>
                            </Box>
                        </Grid>

                        <Grid container spacing={2} mt={4} >
                            <Grid item md={6}>
                                <Box className={commonStyle.commonInput}>
                                    <Typography
                                        className={commonStyle.labelCommonInput}
                                    >
                                        Expiry Date
                                    </Typography>
                                    <TextField
                                        placeholder={"06/26"}
                                        variant="outlined"
                                        className={commonStyle.w100}
                                    />
                                </Box>
                            </Grid>

                            <Grid item md={6}>
                                <Box className={commonStyle.commonInput}>
                                    <Typography
                                        className={commonStyle.labelCommonInput}
                                    >
                                        CVC
                                    </Typography>
                                    <TextField
                                        variant="outlined"
                                        className={commonStyle.w100}
                                    />
                                </Box>
                            </Grid>
                        </Grid> */}
          </Grid>

          <Grid item md={12}>
            <Grid container spacing={0} mt={4}>
              <Grid item md={3}></Grid>
              <Grid item md={6}>
                <Box className={styles.orderSummary}>
                  <div className={styles.orderSummaryChild}>
                    <p className={styles.summeryHeading}>Order summary</p>
                    <div>
                      <div className={styles.summary_Detail_Container}>
                        <p className={styles.title}>Subtotal</p>
                        <p className={styles.value}>
                          {checkoutData?.subtotal
                            ? `$${checkoutData?.subtotal.toFixed(2)}`
                            : "$0.00"}
                        </p>
                      </div>
                      <div className={styles.summary_Detail_Container}>
                        <p className={styles.title}>Tax 7%</p>
                        <p className={styles.value}>
                          {checkoutData?.tax
                            ? `$${checkoutData?.tax.toFixed(2)}`
                            : "$0.00"}
                        </p>
                      </div>
                      <div className={styles.summary_Detail_Container}>
                        <p className={styles.title}>Delivery</p>
                        <p className={styles.value}>
                          {checkoutData?.deliveryRate
                            ? `$${checkoutData?.deliveryRate.toFixed(2)}`
                            : "$0.00"}
                        </p>
                      </div>
                    </div>
                    <div className={styles.borderBottom}></div>
                    <div className={styles.summary_Detail_Container}>
                      <p className={styles.total}>Total</p>
                      <p className={styles.price}>
                        {checkoutData?.subtotal &&
                        checkoutData?.tax &&
                        checkoutData?.deliveryRate
                          ? `$${(
                              checkoutData?.subtotal +
                              checkoutData?.tax +
                              checkoutData?.deliveryRate
                            ).toFixed(2)}`
                          : "$0.00"}
                      </p>
                    </div>
                    <Box className={` ${commonStyle.blueBtn} `}>
                      <Button
                        fullWidth
                        disabled={!checkoutData || isDisabled}
                        style={{
                          fontFamily: "Roboto",
                          fontWeight: "400",
                          fontSize: "20px",
                          alignItems: "center",
                          color: "#fff",
                        }}
                        onClick={onSubmit}
                      >
                        Pay Now {isDisabled ? <ClipLoader /> : ""}
                      </Button>
                    </Box>
                  </div>
                </Box>
              </Grid>
              <Grid item md={3}></Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default StripePaymentMethod;
